var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.456,
    height: 15.708,
    viewBox: "0 0 16.456 15.708",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "mage_filter",
    d: "M17.706,10.317H7.718m-3.525,0H2.75m1.442,0a1.762,1.762,0,1,1,.516,1.246A1.762,1.762,0,0,1,4.192,10.317Zm13.513,5.341H13.059m0,0a1.763,1.763,0,0,1-3.525,0m3.525,0a1.763,1.763,0,0,0-3.525,0m0,0H2.75M17.706,4.975H15.2m-3.525,0H2.75m8.92,0a1.762,1.762,0,1,1,.516,1.246A1.762,1.762,0,0,1,11.67,4.975Z",
    transform: "translate(-2 -2.463)",
    fill: "none",
    stroke: "#111",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.a4b1801697007ce3aaed6bebaba0fa0a.svg";
export { ForwardRef as ReactComponent };